// Porta leve (A06) para `src/app` e `src/routes`: só manifesto, busca e catálogo entram no JS inicial; as
// telas vêm por `import()`.
export {
  AUTOMATIC_SPLIT_PATH,
  automaticSplitFormScreen,
  automaticSplitListScreen,
  automaticSplitPlanScreen,
} from './automatic-split.screen';
export { automaticSplitFormSearch, automaticSplitListSearch, automaticSplitPlanSearch } from './automatic-split.search';
export { loadAutomaticSplitMessages } from './automatic-split.catalog';
export const loadAutomaticSplitScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadAutomaticSplitGuides = () => import('./automatic-split.guide');
